import { fmtDateTime } from '@/lib/format'
import { PersonName } from '@/components/PersonName'
import type { TemplateDetail } from '@/lib/scientific'

/** The experts' recommendations on the whole workflow (and, from older checks, per task), beside the evidence. */
export function ScientificQualityReviews({ data, selected }: { data: TemplateDetail; selected: string }) {
  const latest = new Map<string, NonNullable<TemplateDetail['quality_reviews']>[number]>()
  for (const review of [...(data.quality_reviews ?? [])].sort((a, b) => a.at.localeCompare(b.at)))
    if (!selected || review.target === selected || review.target === 'template') latest.set(`${review.target}:${review.actor.email}`, review)
  if (!latest.size) return null
  return <section className="box" aria-label="Scientist QC recommendations">
    <h2>Scientist QC recommendations</h2>
    {[...latest.values()].map(review => <article key={review.entry_id}>
      <h3>{review.target === 'template' ? 'Whole workflow' : data.tasks.find(task => task.task_id === review.target)?.title ?? review.target} <span className={`chip ${review.verdict === 'ready' ? 'ok' : 'warn'}`}>{review.verdict === 'ready' ? 'Ready' : 'Needs changes'}</span></h3>
      {review.feedback && <p className="prewrap">{review.feedback}</p>}
      <p className="muted small"><PersonName people={data.people} id={review.actor.user_id} email={review.actor.email} fallback="" /> · {fmtDateTime(review.at)}</p>
    </article>)}
  </section>
}
